module.exports = __webpack_public_path__ + "static/media/logo_h_transparent.7f77868e.png";